import { ResponseSuccess } from '@forwardflow/types'
import { apiGet } from './Axios/configs'

export class FubService {
   static async getPeopleSources({
      orgId,
      page,
      limit,
   }: {
      orgId: string
      page: number
      limit: number
   }) {
      const response = await apiGet<
         ResponseSuccess<
            Array<{
               leadSource: string
            }>
         >
      >({
         apiPath: '/people-sources',
         config: {
            params: {
               page,
               limit,
               orgId,
            },
         },
      })
      return response.data
   }

   static async getPonds({
      orgId,
      page,
      limit,
   }: {
      orgId: string
      page: number
      limit: number
   }) {
      const response = await apiGet<
         ResponseSuccess<
            Array<{
               pondId: number
               pondName: string
               pondLeaderId: number
               totalMembers: number
            }>
         >
      >({
         apiPath: `/organizations/${orgId}/fub-ponds`,
         config: {
            params: {
               page,
               limit,
            },
         },
         includeXOrg: false,
      })

      return response.data
   }
}
